import { render, staticRenderFns } from "./TenantList.vue?vue&type=template&id=4b97cd6e&scoped=true&"
import script from "./TenantList.vue?vue&type=script&lang=js&"
export * from "./TenantList.vue?vue&type=script&lang=js&"
import style0 from "./TenantList.vue?vue&type=style&index=0&id=4b97cd6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b97cd6e",
  null
  
)

export default component.exports